import {css} from "@emotion/react";
import React from 'react';
import {useHistory} from "react-router-dom";
import {useLocationById} from "../../../../sdk/queries";
import {useIdvsExceededByDate} from "../../../../sdk/queries";
import {useIdvsExceededByPeriod} from "../../../../sdk/queries";
import {useIdvsByPeriod} from "../../../../sdk/queries";
import {useTrainsSummaryByPeriod} from "../../../../sdk/queries";
import {tracksideMonitoring} from "../../../Routes/urls";
import {Grid} from "../../../Grid";
import {Card} from "../../../TabsRoute/components/Card";
import {column, numberOfCallsText, row, textTotal, textTotalNumber, total, nsCarDiv} from "../../styles";
import {TSMMonitoringContext} from "../../../TSMMonitoring/components/TSMMonitoringProvider";
import {DustFreeSvg} from "../DustFreeSvg";
import nsCar from "../../../../images/ns-car.png"

export const DustAlerts = ({location_id, period_s}:
			   {location_id: number, period_s: string}) => {
    //const {callLogs} = React.useContext(TSMMonitoringContext);
    const history = useHistory();
    const url_suffix = location_id // + "/" + period_s
			       
    const {data, loading} = useLocationById({
	variables: {
	    id: String(location_id),
	}
    });

    const location = data?.data;
    
    const e_idvs = useIdvsExceededByPeriod({
	variables: {
	    location_id: String(location_id),
	    period_date: period_s,
	}
    });

    const exceeded = (e_idvs?.data?.data || []);

    console.log(exceeded);

    const trains_summary = useTrainsSummaryByPeriod({
	variables : {
	    id: String(location_id),
	    period_date: period_s,
	}
    });

    const count = trains_summary?.data?.data?.count
    const avg_speed = trains_summary?.data?.data?.avg_speed
    const empty = trains_summary?.data?.data?.empty_count
    const coal = trains_summary?.data?.data?.coal_count
    const freight = trains_summary?.data?.data?.freight_count

    const idvs = useIdvsByPeriod({
	variables: {
	    id: String(location_id),
	    period_date: period_s,
	}
    });
			       
    return (
        <Card padding={"0 40px"} contentCss={css({backgroundColor: "#F7FBFF"})}>
            <div css={column}
	        onClick={() =>
	            history.push(tracksideMonitoring+url_suffix)}>
                <div css={row}>
                    <div css={total}>
            <p css={textTotal}>{location?.name}</p>
                    </div>
                </div>
                <div css={row}>
            <div css={nsCarDiv}>
            <img width="200px" src={nsCar} />
                    </div>
                </div>
            <div css={row}>
                    <p css={numberOfCallsText}>High Dust Alert:</p>
                    <p css={textTotalNumber}>{exceeded.length}</p>
                </div>
                <div css={row}>
                  <p css={numberOfCallsText}>Total # Monitored: {count}</p>
                  <p css={numberOfCallsText}>Total # Coal Trains: {coal}</p>
		  <p css={numberOfCallsText}>Total # Empty Coal Trains: {empty}</p>
                  <p css={numberOfCallsText}>Total # Freight Trains: {freight}</p>
	          <p css={numberOfCallsText}>Average Train Speed: {avg_speed}</p>
                </div>
            </div>
        </Card>

    );
};
